import { render, staticRenderFns } from "./DashboardCheckups.vue?vue&type=template&id=cdd59a08"
import script from "./DashboardCheckups.vue?vue&type=script&lang=ts"
export * from "./DashboardCheckups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports